export default __webpack_public_path__ + "static/media/R.7e822c6c.svg";